import { createSlice } from "@reduxjs/toolkit";
import mcli from "../../libs/matrix";
const initialState = {
    authorization: {},
    name: "",
    imageUrl: "",
    userId: "",
};
export const userSlice = createSlice({
    name: "user",
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        updateMatrixProfile: (state) => {
            const me = mcli.getUser(mcli.getUserId() || "");
            if (me) {
                state.name = me.displayName || "";
                state.imageUrl = mcli.mxcUrlToHttp(me.avatarUrl || "") || "";
                state.authorization = {
                    token: mcli.getAccessToken(),
                };
                state.userId = mcli.getUserId() || "";
            }
            return state;
        },
        clear: () => {
            return {
                authorization: {},
                name: "",
                imageUrl: "",
                userId: "",
            };
        },
    },
});
export const { updateMatrixProfile, clear } = userSlice.actions;
export const selectAuthorization = (state) => state.user.authorization;
export const selectName = (state) => state.user.name;
export const selectImageUrl = (state) => state.user.imageUrl;
export default userSlice.reducer;
